<template>
  <div>
    <div class="x-banner">
      <!-- banner -->
      <BANNER></BANNER>
      <!-- 二级导航 -->
      <NAVIGATION
        :data="navigationData"
        :currentPath="currentPath"
      ></NAVIGATION>
    </div>
    <div class="container-width location">
      当前位置:<router-link to="/">首页</router-link> >
      <router-link to="/lxwm/letters">来信统计</router-link> >
      {{ current.title }}
    </div>
    <div class="container-width">
      <ARTICLE
        :current="current"
        :before="before"
        :after="after"
        :showBeforeAfter="showBeforeAfter"
        :showorigin="showorigin"
        @changePage="handleChangePage"
      ></ARTICLE>
    </div>
  </div>
</template>
<script>
import service from "../../../service/lxwm";
import BANNER from "../../../components/banner/lxwm";
export default {
  name: "LETTERSDETAIL",
  data() {
    return {
      navigationData: [
        {
          name: "给院长写信",
          path: "/lxwm/dean",
        },
        // {
        //   name: "来信统计",
        //   path: "/lxwm/letters",
        // },
        // {
        //   name: "来信选登",
        //   path: "/lxwm/digest",
        // },
        // {
        //   name: "来信回复",
        //   path: "/lxwm/reply",
        // },
        {
          name: "纪检监察",
          path: "/lxwm/discipline",
        },
      ],
      currentPath: "/lxwm/letters",
      current: {
        title: "",
        description: "",
        releaseDate: "",
        views: "",
        origin: "",
      },
      // 上一篇
      before: {
        title: "",
        id: "",
        active: false,
      },
      // 下一篇
      after: {
        title: "",
        id: "",
        active: false,
      },
      showBeforeAfter: true, //是否显示上一篇 下一篇
      showorigin: true, //是否显示来源 发布时间 点击次数
      showContent: false, // 文章加载后 显示
    };
  },
  components: { BANNER },
  computed: {},
  created() {},
  beforeMount() {},
  methods: {
    init() {
      this.startLoading();
      let parmes = {
        id: this.$route.query.id,
      };

      service.getLetterCountInfo(parmes, (res) => {
        this.showContent = true;
        res.current.releaseDate = res.current.releaseDate
          ? res.current.releaseDate.split(" ")[0]
          : "";

        res.current.description = res.current.description.replace(
          /<table[^>]*>/gi,
          function (match, capture) {
            return match.replace(/width=\"(.*)\"/gi, "style='width:90%'");
          }
        );

        this.current = { ...res.current };
        if (res.before) {
          this.before = { ...res.before };
          this.before.active = true;
        } else {
          this.before.title = "已经没有上一篇";
          this.before.active = false;
        }
        if (res.after) {
          this.after = { ...res.after };
          this.after.active = true;
        } else {
          this.after.title = "已经没有下一篇";
          this.after.active = false;
        }
        this.Loading.close();
      });
    },
    // 上一篇 下一篇
    handleChangePage(id) {
      const query = JSON.parse(JSON.stringify(this.$route.query)); // 获取路由参数信息
      query.id = id; //改变参数
      this.$router.push({ path: this.$route.path, query }); //更新路由
      this.init();
    },

    startLoading() {
      //使用Element loading-start 方法
      this.Loading = this.$loading({
        lock: true,
        text: "加载中……",
        background: "rgba(0, 0, 0, 0.7)",
        target: document.querySelector("#app"), //loadin覆盖的dom元素节点
        body: true,
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {},
};
</script>

<style lang="scss" scoped>
.content table {
  max-width: 90vw;
}
</style>
